import * as React from 'react';

interface OptionsEditorProps {
  value: string[];
  onChange: (options: string[]) => void;
}

export default function OptionsEditor({ value, onChange }: OptionsEditorProps) {
  const [items, setItems] = React.useState<string[]>(value || []);
  const [newItem, setNewItem] = React.useState('');

  React.useEffect(() => { setItems(Array.isArray(value) ? value : []); }, [value]);

  function addItem() {
    const v = newItem.trim();
    if (!v) return;
    if (items.includes(v)) return; // avoid duplicates
    const next = [...items, v];
    setItems(next);
    onChange(next);
    setNewItem('');
  }

  function updateItem(idx: number, val: string) {
    const v = val.trim();
    const next = items.map((it, i) => (i === idx ? v : it)).filter(x => x !== '');
    setItems(next);
    onChange(next);
  }

  function removeItem(idx: number) {
    const next = items.filter((_, i) => i !== idx);
    setItems(next);
    onChange(next);
  }

  const inputStyle: React.CSSProperties = { padding:'4px 6px', fontSize:14, borderRadius:4, border:'1px solid #cfd8dc', background:'#f7fafd', width:'100%' };
  const buttonPrimary: React.CSSProperties = { padding:'6px 10px', borderRadius:6, background:'#4e6e8e', color:'#fff', fontWeight:600, border:'none', cursor:'pointer' };
  const buttonSecondary: React.CSSProperties = { ...buttonPrimary, background:'#e0e6ed', color:'#123', fontWeight:500 };
  const buttonDanger: React.CSSProperties = { ...buttonPrimary, background:'#c62828' };

  return (
    <div style={{ display:'flex', flexDirection:'column', gap:8 }}>
      <div style={{ display:'grid', gridTemplateColumns:'1fr 120px', gap:8 }}>
        <input placeholder="Add option" value={newItem} onChange={e=>setNewItem(e.target.value)} style={inputStyle} />
        <button type="button" onClick={addItem} style={buttonPrimary}>Add</button>
      </div>
      <div>
        {items.length === 0 ? (
          <div style={{ color:'#789' }}>No options</div>
        ) : (
          <ul style={{ listStyle:'none', padding:0, margin:0 }}>
            {items.map((opt, idx) => (
              <li key={idx} style={{ display:'grid', gridTemplateColumns:'1fr 90px', gap:8, alignItems:'center', marginBottom:6 }}>
                <input value={opt} onChange={e=>updateItem(idx, e.target.value)} style={inputStyle} />
                <button type="button" onClick={()=>removeItem(idx)} style={buttonDanger}>Remove</button>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
